<template>
  <div>
    <ul class="tabs" v-if="userId">
      <li v-for="tab in tabs" :key="tab.id" :class="{ active: tab.id === activeTab }" @click="activeTab = tab.id">
        {{ tab.name }}
      </li>
    </ul>
    <div v-if="activeTab === 1" class="build">
      <div v-if="!isLoading" class="build-wrapper">
        <div class="custom-cover">
          <Cover
            id="cover"
            :bgConfig="coverData.bgParameter"
            :elementImg="coverData.elementImg"
            :size="coverData.size"
            :elConfig="coverData.elementInfo"
            :textConfig="coverData.textInfo"
            :fontStyles="coverData.fontStyles"
          />
          <portrait
            v-if="isHorizontal"
            :isAllowDelete="true"
            :selectedId="coverData.elementId"
            :portraitMap="portraitMap"
            @getPortraits="getPortraits"
            @selectPortrait="selectPortrait"
            @deletePortrait="deletePortrait"
          ></portrait>
        </div>
        <theme
          :themes="themes"
          :currentTagId="coverData.tagId"
          @updateMaterials="updateMaterials"
          @regainMaterials="regainMaterials"
        >
        </theme>
        <div class="custom-texts">
          <cover-input
            v-for="(fontStyle, index) in coverData.fontStyles"
            :key="'line' + index"
            :themeColor="coverData.bgParameter.tagBgColor"
            :fontStyle="fontStyle"
            @changeInputUsable="changeInputUsable"
            @changeLabelStyle="changeLabelStyle"
            @mainInput="handleMainInput"
          />
          <el-button slot="tool" type="primary" round @click="onGenerate" :disabled="!isTextLegal"
            >生成并上传</el-button
          >
        </div>
      </div>
      <RightNav
        :backgrounds="coverBackgrounds"
        :elements="coverElements"
        :textStyles="coverTextStyles"
        :onDrawData="coverData"
        :isCover="true"
        @updateBackground="selectBackground"
        @updateElement="selectElement"
        @switchElement="selectElement"
      />
      <span class="loading" v-show="isUploading"
        ><span class="text"><i class="el-icon-loading"></i> 正在上传</span></span
      >
    </div>
    <cover-designs
      v-if="activeTab === 2"
      :designData="designData"
      :userId="userId"
      :sizeId="coverSizeId"
      @getMyDesigns="getMyDesigns"
      @showDesignDetail="showDesignDetail"
    ></cover-designs>
  </div>
</template>
<script>
import { freshItemOfArr, genMaterialData, isPortraitMaterialType, randomItemExcept } from "@/assets/scripts/common.js";
import { getBackgrounds, getElements, getPortraits, getTagColor, htmlToCanvas } from "@/assets/scripts/features";
import portrait from "@/components/portrait.vue";
import RightNav from "@/components/RightNav.vue";
import coverDesigns from "@/pages/specific/components/cover-designs.vue";
import theme from "@/components/theme.vue";
import { getCoverSizes, getSizeInfoBySizeId } from "@/pages/ai/js/ai-feature";
import Cover from "@/pages/cover/components/cover.vue";
import coverInput from "@/pages/cover/components/coverInput.vue";
import {
  checkCoverText,
  genCoverDataBySize,
  setCoverData,
  setTextStyleMap,
  getCoverDataBySchemeId,
  saveCoverToBase,
  getCoverTextStyles,
} from "@/pages/cover/js/cover-feature";
import { mapMutations, mapState } from "vuex";
import { onUpload, getUserCovers } from "./specific-feature";
export default {
  name: "build",
  data() {
    return {
      themes: [],
      // 用户头像列表数据
      portraitMap: {},
      schemeId: "",
      isLoading: true,
      isUploading: false,
      sizes: [],
      uploadUrl: "https://shopcenter.xkw.com/info/shop/premote",
      tabs: [
        {
          name: "制作图片",
          id: 1,
        },
        { name: "我的设计", id: 2 },
      ],
      activeTab: 1,
      userId: "",
      designData: {
        list: [],
        totalCount: 0,
        totalPage: 0,
      },
      coverSizeId: "",
    };
  },
  components: {
    coverInput,
    Cover,
    theme,
    portrait,
    RightNav,
    coverDesigns,
  },
  mounted() {
    this.init();
    const uploadUrl = this.$route.query.uploadUrl;
    if (uploadUrl) {
      this.uploadUrl = uploadUrl;
    }
    this.userId = this.$route.query.userId;
  },
  computed: {
    isHorizontal() {
      const { width, height } = this.coverData.size;
      return width > height;
    },
    ...mapState("cover", ["coverBackgrounds", "coverData", "coverTextStyles", "coverElements"]),
    // 输入是否合法
    isTextLegal: {
      get() {
        if (!this.coverData || !this.coverData.fontStyles || !this.coverData.fontStyles.length) {
          return false;
        }
        return checkCoverText(this.coverData.fontStyles);
      },
      set() {},
    },
  },
  methods: {
    ...mapMutations("cover", ["setCoverElements", "updateCoverDataList", "updateCoverData", "setCoverFontStyles"]),
    async init() {
      this.coverSizeId = this.$route.query.id || 88;
      console.log("this.coverSizeId", this.coverSizeId);
      this.isLoading = true;
      this.themes = await getTagColor();
      const defaultTagId = this.themes[0].id;
      // 获取封面的业务线（sizes）
      Promise.all([
        getBackgrounds(defaultTagId, 2),
        getElements(defaultTagId, 2),
        getPortraits(),
        getCoverSizes(),
        getCoverTextStyles(this.coverSizeId),
      ]).then(([bgs, eles, portraitMap, coverSizes, textStyles]) => {
        this.portraitMap = portraitMap;
        // 设置素材列表
        this.setCoverElements({
          backgrounds: bgs,
          elements: eles,
        });
        this.setCoverFontStyles(textStyles);
        const background = freshItemOfArr(bgs);
        const element = freshItemOfArr(eles);
        const coverSize = getSizeInfoBySizeId(coverSizes, this.coverSizeId);
        const cover = genCoverDataBySize(coverSize, element, background);
        cover.fontStyles = cover.fontStyles.map((style, i) => {
          style.text = undefined;
          return setTextStyleMap(style, i);
        });
        console.log("cover", cover);
        this.updateCoverData(cover);
        this.isLoading = false;
      });
    },
    // 获取头像列表
    async getPortraits(params) {
      this.portraitMap = await getPortraits(params);
    },
    async getMyDesigns(params) {
      this.designData = await getUserCovers(params);
    },
    // 切换输入框的显示/隐藏
    changeInputUsable(textStyleMap) {
      // 更新coverData.fontStyles的文字显示状态
      const textStatus = !textStyleMap.isShowText;
      this.updateCoverData({
        data: textStyleMap,
        key: "isShowText",
        value: textStatus,
      });
    },
    // 处理主标题换行
    handleMainInput(fontStyle, text) {
      this.updateCoverData({
        data: fontStyle,
        key: "text",
        value: text,
      });
    },
    // 切换文字的背景边框样式
    changeLabelStyle({ lineIndex, labelData }) {
      // 更新coverData.fontStyles的文字样式(边框圆角背景)
      this.updateCoverData({
        data: this.coverData.fontStyles,
        key: lineIndex,
        value: {
          ...this.coverData.fontStyles[lineIndex],
          labelStyle: labelData.name,
        },
      });
    },
    // 选中老师肖像
    selectPortrait(portrait) {
      setCoverData(this, portrait);
    },
    // 删除老师肖像
    deletePortrait() {
      const element = freshItemOfArr(this.coverElements);
      setCoverData(this, element);
    },
    // 更新素材
    updateMaterials() {
      const background = randomItemExcept(this.coverBackgrounds, this.coverData.backgroundId);
      const element = randomItemExcept(this.coverElements, this.coverData.elementId);
      // 如果选中了教师头像，只更新背景不更新素材
      if (this.isPortraitMaterialType(this.coverData.elementTypeId)) {
        setCoverData(this, null, background);
      } else {
        setCoverData(this, element, background);
      }
    },
    // 右侧列表切换素材
    selectElement(material) {
      setCoverData(this, material);
    },
    // 右侧列表切换背景
    selectBackground(material) {
      setCoverData(this, null, material);
    },
    // 重新获取素材
    regainMaterials({ id }) {
      // this.updateCoverData({ tagId: id });
      Promise.all([getBackgrounds(id, 2), getElements(id, 2)]).then(([backgrounds, elements]) => {
        // 设置素材列表
        this.setCoverElements({
          elements,
          backgrounds,
        });
        const element = elements[0];
        const background = backgrounds[0];
        let data = genMaterialData(element, background);
        // 如果选中了教师头像，只更新背景不更新素材
        if (this.isPortraitMaterialType(this.coverData.elementTypeId)) {
          data = genMaterialData(null, background);
        }
        this.updateCoverData({
          tagId: id,
          ...data,
        });
        this.updateCoverDataList({
          tagId: id,
          ...data,
        });
      });
    },
    async onGenerate() {
      if (!this.isTextLegal) return;
      this.isUploading = true;
      let dom = document.querySelector("#cover");
      if (this.userId) {
        saveCoverToBase([this.coverData], this.schemeId, this.userId);
      }
      const bannerBase64Data = await htmlToCanvas(dom, 2);
      await onUpload(bannerBase64Data, this.uploadUrl);
      this.isUploading = false;
    },
    async showDesignDetail(schemeId) {
      this.activeTab = 1;
      this.schemeId = schemeId;
      const list = await getCoverDataBySchemeId(schemeId);
      if (list.length) {
        this.updateCoverData(list[0]);
      }
      Promise.all([getBackgrounds(this.coverData.tagId, 1), getElements(this.coverData.tagId, 1)]).then(
        ([bgs, eles]) => {
          this.setCoverElements({
            backgrounds: bgs,
            elements: eles,
          });
        }
      );
    },
  },
};
</script>
<style lang="scss" scoped>
.tabs {
  display: flex;
  justify-content: start;
  align-items: center;
  height: 50px;
  width: 800px;
  margin: 0 calc(50vw - 400px - 150px);
  li {
    cursor: pointer;
    line-height: 50px;
    width: 100px;
    text-align: center;
    color: #999;
    &.active {
      color: #3f69f9;
    }
  }
}
.build {
  height: calc(100% - 60px);

  .build-wrapper {
    position: relative;
    width: 800px;
    height: calc(100% - 60px);
    margin: 0 calc(50vw - 400px - 150px);
    transition: all 0.2s;

    @mixin bg {
      margin-top: 30px;
      padding: 0 30px;
      background: rgba(255, 255, 255, 0.4);
      box-shadow:
        0px 6px 10px 0px rgba(0, 0, 0, 0.06),
        0px 1px 0px 0px #ffffff,
        -1px -1px 1px 0px #eceef5;
      border-radius: 6px;
    }

    .custom-cover {
      display: flex;
      justify-content: flex-start;
      align-items: flex-end;
      margin-top: 25px;
      background-size: 150% 150%;

      img {
        width: 100%;
      }
    }

    .custom-texts {
      margin: 30px 0;
      @include bg;
      padding: 30px;
      position: relative;
    }
  }
}
.loading {
  &::after {
    position: fixed;
    content: "";
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 9998;
    background: rgba(0, 0, 0, 0.5);
  }

  .text {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    padding: 10px 20px;
    border-radius: 6px;
    z-index: 9999;
    background: #fff;
  }
}
</style>
